<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">Embers on the Western Wind: Precursors to War in Southwest Missouri</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">The Torch Is Lit: War Comes to Southwest Missouri</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">The Battle of Carthage</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Wartime Experiences in the West Plains Area</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">The Battle of Wilson’s Creek</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Springfield, Missouri: Civil War Headquarters</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Guerrilla Warfare: Southwest Missouri Becomes the “Burnt District”</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Thomas R. Livingston, Southwest Missouri Guerrilla Leader</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Bushwhackers Beware</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Newton County: The Confederate Capital of Missouri</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">The Rothanbarger House: Union Man in Confederate Country</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">A Civil War Haunting: Paranormal Science Lab Investigates Kendrick House and the Battle of Carthage Battlefield</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?97376fea